import { Controller } from "@hotwired/stimulus";
import gsap from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin)

export default class extends Controller {
    static targets = ['item', 'label', 'drawer', 'image'];


    tl = gsap.timeline();


    connect() {
        this.labelTargets.forEach((label) => {
            label.addEventListener("click", this.toggleDrawer);
            label.addEventListener("keydown", (event) => {
                if (event.key === "Enter") {
                    this.toggleDrawer(event);
                }
            });
        });

        this.itemTargets.forEach((item) => {
            if (item.classList.contains("initially-open")) {
                const drawer = item.querySelector(".accordion__list-item__drawer");
                this.tl.set(drawer, {
                    height: 'auto',
                    opacity: 1,
                });
            }
        });
    }

    initialize() {
        this.tabIndexOff(this.element);
    }

    tabIndexOff(element) {
        element.querySelectorAll('a').forEach(link => {
            link.setAttribute("tabindex", "-1");
        });
        
        element.querySelectorAll('button').forEach(link => {
            link.setAttribute("tabindex", "-1");
        });
    }

    tabIndexOn(element) {
        element.querySelectorAll('a').forEach(link => {
            link.setAttribute("tabindex", "0"); 
        });
        
        element.querySelectorAll('button').forEach(link => {
            link.setAttribute("tabindex", "0"); 
        });
    }

    toggleDrawer = (event) => {
        // Find the drawer element within the same item container
        const item = event.currentTarget.closest(".accordion__list-item");
        const isOpen = item.classList.contains("open") || item.classList.contains("initially-open");
        const drawer = item.querySelector(".accordion__list-item__drawer");
        
        const itemIndex = item.dataset.index;
        this.imageTargets.forEach((image) => {
            if (image.dataset.index === itemIndex) {
                image.classList.add("visible");
            } else {
                image.classList.remove("visible");
            }
        });

        // Close all other open items first
        const openItems = this.itemTargets.filter((otherItem) => {
            return otherItem !== item && (otherItem.classList.contains("open") || otherItem.classList.contains("initially-open"));
        });

        openItems.forEach((openItem) => {
            const otherDrawer = openItem.querySelector(".accordion__list-item__drawer");
            gsap.to(otherDrawer, {
                height: 0,
                opacity: 0,
                overflow: 'hidden',
                duration: 0.25,
                onComplete: () => {
                    openItem.classList.remove("initially-open", "open");
                    this.tabIndexOff(openItem);
                }
            });
        });

        if (drawer) {
            if (!isOpen) {
                // Opening the drawer
                const offset = 96;

                const headerHeight = document.querySelector('.header').offsetHeight || 0;
                const totalOffset = offset + headerHeight;
                
                // First animate the drawer
                gsap.timeline()
                    .to(drawer, {
                        height: 'auto',
                        opacity: 1,
                        overflow: 'visible',
                        duration: 0.25,
                        onStart: () => {
                            item.classList.add("open");
                            this.tabIndexOn(item);
                        }
                    })
                    // Then scroll to position after drawer is open
                    .to(window, {
                        duration: 0.25,
                        scrollTo: {
                            y: item,
                            offsetY: totalOffset,
                            autoKill: false
                        }
                    });
            } else {
                // Closing the drawer
                gsap.to(drawer, {
                    height: 0,
                    opacity: 0,
                    overflow: 'hidden',
                    duration: 0.25,
                    onComplete: () => {
                        item.classList.remove("initially-open", "open");
                        this.tabIndexOff(item);
                    }
                });
            }
        }
    }
}
